import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

export const classes = {
  root: css`
    align-items: flex-start;
    display: flex;
    position: relative;
    padding: 0;
    z-index: 10;
  `,
  logo: css`
    margin-right: ${spacing(1.25)};
  `,
  banner: css`
    flex-grow: 1;
  `,
}
